// IMPORTANT: Keep in sync with GTM "[Consent] Default" Tag
// Keep updated with regulations
export const COUNTRIES_REQUIRES_CONSENT = [
  'Austria',
  'Andorra',
  'Belgium',
  'Bulgaria',
  'Cyprus',
  'Czechia',
  'Germany',
  'Denmark',
  'Estonia',
  'Spain',
  'Finland',
  'France',
  'Croatia',
  'Hungary',
  'Ireland',
  'Iceland',
  'Italy',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Latvia',
  'Malta',
  'Netherlands',
  'Poland',
  'Portugal',
  'Romania',
  'Sweden',
  'Slovenia',
  'Slovakia',
  'Switzerland',
  'Norway',
  //
  'United Kingdom',
  //
  'Brazil',
  'South Africa',
  'Argentina',
  'Chile',
  'Turkey',
];
